// extracted by mini-css-extract-plugin
export default {"root":"InputLabel_root__qSQOz","rootSmall":"InputLabel_rootSmall__I4tHz InputLabel_root__qSQOz"};